module.exports = __webpack_public_path__ + "images/6919d09b7d98011d5605ce1b75992c5a972059b26d64b49ec22ba51ba6224a13.svg";